import { TLocale } from "@rsonav/shared-config";
import { EGeoObjectStatus } from "@rsonav/protocol";

export const geoStatusesList: { [key: string]: { localeKey: keyof TLocale } } = {
	[EGeoObjectStatus.New]: { localeKey: "geo_objectStatusNew" },
	[EGeoObjectStatus.Approved]: { localeKey: "geo_objectStatusApproved" },
	[EGeoObjectStatus.Rejected]: { localeKey: "geo_objectStatusRejected" },
};
